import { render, staticRenderFns } from "./StocktakingCorrection.vue?vue&type=template&id=4bb853d1&scoped=true&"
import script from "./StocktakingCorrection.vue?vue&type=script&lang=js&"
export * from "./StocktakingCorrection.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingCorrection.vue?vue&type=style&index=0&id=4bb853d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb853d1",
  null
  
)

export default component.exports